import { Tooltip } from "azure-devops-ui/TooltipEx";
import { css } from "azure-devops-ui/Util";
import React from "react";
import { formatDate } from "../../../common/utilities/format";

export interface IDateRange {
  endDate: Date;
  startDate: Date;
}

export interface IDateRangeProps {
  className?: string;
  dateRange: IDateRange;
}

export function DateRange(props: IDateRangeProps): React.ReactElement {
  const {
    className,
    dateRange: { endDate, startDate }
  } = props;

  const dateText =
    endDate.getFullYear() === startDate.getFullYear()
      ? endDate.getMonth() === startDate.getMonth() && endDate.getDate() === startDate.getDate()
        ? formatDate(startDate, "long")
        : `${formatDate(endDate, "short")} - ${formatDate(startDate, "long")}`
      : `${formatDate(endDate, "long")} - ${formatDate(startDate, "long")}`;

  return (
    <Tooltip overflowOnly={true}>
      <time className={css(className, "text-ellipsis")}>{dateText}</time>
    </Tooltip>
  );
}
